module.exports = __webpack_public_path__ + "static/media/undraw_stars_re_6je7.9a963d75.svg";